var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.code)?_c('KChip',_vm._b({attrs:{"medium":_vm.medium,"title":'Http Status Code ' + _vm.code}},'KChip',_vm.classes,false),[_vm._v(_vm._s(_vm.code))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }